<main class="minha_conta">
  <section class="minha_conta__section minha_conta__section--left">
    <mat-expansion-panel class="minha_conta__section__panel" expanded disabled>
      <mat-expansion-panel-header class="minha_conta__section__panel__header">
        <mat-panel-title class="minha_conta__section__panel__header__title">
          Dados pessoais
        </mat-panel-title>
      </mat-expansion-panel-header>
      <mat-panel-description class="minha_conta__section__panel__description">
        <form class="minha_conta__section__panel__description__form" [formGroup]="form">
          <mat-form-field class="minha_conta__section__panel__description__form__input" appearance="outline">
            <mat-label>Nome fantasia</mat-label>
            <input matInput formControlName="nome">
          </mat-form-field>
          <mat-form-field class="minha_conta__section__panel__description__form__input" appearance="outline">
            <mat-label>E-mail</mat-label>
            <input matInput formControlName="email">
          </mat-form-field>
          <app-telefone-intl [control]="this.form.get('telefone')" labelCustom="Telefone"></app-telefone-intl>
        </form>
      </mat-panel-description>
    </mat-expansion-panel>
  </section>

  <section class="minha_conta__section minha_conta__section--right">
    <mat-expansion-panel class="minha_conta__section__panel" expanded disabled>
      <mat-expansion-panel-header class="minha_conta__section__panel__header">
        <mat-panel-title class="minha_conta__section__panel__header__title">
          Alterar senha
        </mat-panel-title>
      </mat-expansion-panel-header>
      <mat-panel-description class="minha_conta__section__panel__description">
        <form class="minha_conta__section__panel__description__form" [formGroup]="form">
          <mat-form-field class="minha_conta__section__panel__description__form__input" appearance="outline">
            <mat-label>Senha atual</mat-label>
            <input type="{{ passwordVisible ? 'text' : 'password' }}" matInput formControlName="senhaAtual">
            <button class="minha_conta__section__panel__description__form__input__button" type="button" mat-icon-button matSuffix (click)="passwordVisible = !passwordVisible">
              <mat-icon class="alterar_senha__section__form__input__icon">
                {{ passwordVisible ? 'visibility' : 'visibility_off' }}
              </mat-icon>
            </button>
          </mat-form-field>

          <mat-form-field class="minha_conta__section__panel__description__form__input" appearance="outline">
            <mat-label>Nova senha</mat-label>
            <input type="{{ passwordVisible ? 'text' : 'password' }}" matInput formControlName="senha">
            <button class="minha_conta__section__panel__description__form__input__button" type="button" mat-icon-button matSuffix (click)="passwordVisible = !passwordVisible">
              <mat-icon class="alterar_senha__section__form__input__icon">
                {{ passwordVisible ? 'visibility' : 'visibility_off' }}
              </mat-icon>
            </button>
          </mat-form-field>

          <mat-form-field class="minha_conta__section__panel__description__form__input" appearance="outline">
            <mat-label>Confirmar senha</mat-label>
            <input type="{{ passwordVisible ? 'text' : 'password' }}" matInput formControlName="confirmarSenha">
            <button class="minha_conta__section__panel__description__form__input__button" type="button" mat-icon-button matSuffix (click)="passwordVisible = !passwordVisible">
              <mat-icon class="alterar_senha__section__form__input__icon">
                {{ passwordVisible ? 'visibility' : 'visibility_off' }}
              </mat-icon>
            </button>
          </mat-form-field>

          <mat-error class="login__section_right__form__error" *ngIf="form.hasError('confirmarSenha')">
            As senhas não conferem
          </mat-error>
        </form>
      </mat-panel-description>
    </mat-expansion-panel>
  </section>

  <footer class="minha_conta__footer">
    <div class="minha_conta__footer__message minha_conta__footer__message--error" *ngIf="isError">
      {{ errorMessage }}
      <mat-icon class="minha_conta__footer__message__icon">error</mat-icon>
    </div>

    <div class="minha_conta__footer__message minha_conta__footer__message--success" *ngIf="isSuccess">
      <span class="minha_conta__footer__message__text">Dados atualizados com sucesso</span>
      <mat-icon class="minha_conta__footer__message__icon">check_circle</mat-icon>
    </div>

    <app-ellipsis-animation *ngIf="isSubmitting" />

    <button class="minha_conta__footer__button" mat-raised-button color="primary" (click)="submit()" [disabled]="!form.valid || isSubmitting">
      Salvar
    </button>
  </footer>
</main>
